import { ApolloClient, createQueryPreloader } from '@apollo/client'
import cache from './cache'
/** @import {PreloadQueryFunction} from "@apollo/client" */

const initializeApolloClient = () => {
  const apolloClient = new ApolloClient({
    cache,
    connectToDevTools: true,
    defaultOptions: {
      watchQuery: {
        errorPolicy: 'all'
      }
    }
  })
  return apolloClient
}

/** @type {ReturnType<typeof initializeApolloClient> | null} */
let apolloClientInstance = null

/** @type {PreloadQueryFunction | null} */
let queryPreloader = null

export const getApolloClient = () => {
  if (!apolloClientInstance) {
    apolloClientInstance = initializeApolloClient()
  }
  return apolloClientInstance
}

/**
 * @type {PreloadQueryFunction}
 */
export const preloadQuery = (...args) => {
  if (!queryPreloader) {
    queryPreloader = createQueryPreloader(getApolloClient())
  }
  return queryPreloader(...args)
}
